import { useEffect, useState } from "react";

const useCatalog = (url, collectionKey) => {
  const [state, setState] = useState({ url: "", items: [], loading: false, error: "" });
  useEffect(() => {
    if (!url) return undefined;
    const controller = new AbortController();
    setState({ url, items: [], loading: true, error: "" });
    const load = async () => {
      try {
        const response = await fetch(url, { signal: controller.signal });
        if (!response.ok) throw new Error("No fue posible cargar los catálogos. Recargue la página para reintentar.");
        const data = await response.json();
        const items = collectionKey ? data[collectionKey] : data;
        if (!controller.signal.aborted) setState({ url, items: Array.isArray(items) ? items : [], loading: false, error: "" });
      } catch (error) {
        if (!controller.signal.aborted) setState({ url, items: [], loading: false, error: "No fue posible cargar los catálogos. Recargue la página para reintentar." });
      }
    };
    load();
    return () => controller.abort();
  }, [url, collectionKey]);
  return url && state.url === url ? state : { items: [], loading: Boolean(url), error: "" };
};

const useCatalogs = (apiBaseUrl, form) => {
  const geoUrl = (type, parentKey, parentId) => apiBaseUrl && (!parentKey || parentId)
    ? `${apiBaseUrl}/public/geo-catalogs?${new URLSearchParams({ type, ...(parentKey ? { [parentKey]: parentId } : {}) })}`
    : "";
  const provinces = useCatalog(geoUrl("provinces"));
  const specialities = useCatalog(apiBaseUrl ? `${apiBaseUrl}/public/medical-specialities` : "", "items");
  const physicalMunicipalities = useCatalog(geoUrl("municipalities", "provinceId", form.physicalProvince));
  const physicalSectors = useCatalog(geoUrl("sectors", "municipalityId", form.physicalMunicipality));
  const businessMunicipalities = useCatalog(geoUrl("municipalities", "provinceId", form.businessProvince));
  const businessSectors = useCatalog(geoUrl("sectors", "municipalityId", form.businessMunicipality));
  const catalogs = { provinces, specialities, physicalMunicipalities, physicalSectors, businessMunicipalities, businessSectors };

  return {
    ...Object.fromEntries(Object.entries(catalogs).map(([key, catalog]) => [key, catalog.items])),
    isLoadingSpecialities: specialities.loading,
    catalogError: Object.values(catalogs).find((catalog) => catalog.error)?.error || "",
  };
};

export default useCatalogs;
